import { PageHeader } from "@/components/Layout";
import { ShopSyncCard } from "@/components/ShopSyncCard";

export default function StorePage() {
  return (
    <div>
      <PageHeader eyebrow="Your shop" title="softspinepress.com" />
      <div className="px-6 md:px-12 py-10 space-y-6">
        <ShopSyncCard />
        <p className="text-sm text-[#5C5255] max-w-2xl" data-testid="store-no-payments-note">
          Payments and checkout happen only on softspinepress.com. This app writes and builds your titles, sends them to the store, and can still email a download link by hand from Deliveries.
        </p>
      </div>
    </div>
  );
}
